var map = {
	"./brasao.png": "eaa4",
	"./brasao_2.png": "d27e",
	"./clebs.jpg": "702c",
	"./henrique.jpg": "0adf",
	"./icone.png": "da3d",
	"./jana.jpeg": "0c36",
	"./logo-escola.png": "4202",
	"./logo.png": "9d64",
	"./parallaximg.png": "a776"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";